import Step1 from './step-1'
import Step2 from './step-2'
import Step3 from './step-3'

export default function getStepContent(
	step,
	changeValidationStep3,
	selectSignature,
	rowData,
	// Standard Report State
	reportTypes,
	currentFilledFormIndex,
	// Standard Report Answers
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	dataSetFilesUpload,
	// Validation
	currentSelectedError,
	openValidationModal,
	onOpenValidationModal,
	onCloseValidationModal,
	// Flags
	operatorFlag,
	// Reject Reason
	rejectReason,
	setRejectReason,
	// version
	reportVersion
) {
	switch (step) {
		case 0:
			return <Step1 rowData={rowData} dataSetFilesUpload={dataSetFilesUpload} />
		case 1:
			return (
				<Step2
					quarter={rowData?.quarter}
					list={reportTypes}
					currentFilledFormIndex={currentFilledFormIndex}
					fixedGeneralAnswers={fixedGeneralAnswers}
					fixedInfoAnswers={fixedInfoAnswers}
					fixedSoundAnswers={fixedSoundAnswers}
					mobileGeneralAnswers={mobileGeneralAnswers}
					mobileInfoAnswers={mobileInfoAnswers}
					mobileSoundAnswers={mobileSoundAnswers}
					// Validation
					currentSelectedError={currentSelectedError}
					openValidationModal={openValidationModal}
					onOpenValidationModal={onOpenValidationModal}
					onCloseValidationModal={onCloseValidationModal}
					operatorFlag={operatorFlag}
					// version
					reportVersion={reportVersion}
				/>
			)
		case 2:
			return (
				<Step3
					changeValidationStep3={changeValidationStep3}
					selectSignature={selectSignature}
					rejectReason={rejectReason}
					setRejectReason={setRejectReason}
				/>
			)
		default:
			return 'Unknown step'
	}
}
